/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconViewportWide = createReactComponent("viewport-wide", "IconViewportWide", [
  ["path", { d: "M10 12h-7l3 -3m0 6l-3 -3", key: "svg-0" }],
  ["path", { d: "M14 12h7l-3 -3m0 6l3 -3", key: "svg-1" }],
  ["path", { d: "M3 6v-3h18v3", key: "svg-2" }],
  ["path", { d: "M3 18v3h18v-3", key: "svg-3" }]
]);

export { IconViewportWide as default };
//# sourceMappingURL=IconViewportWide.js.map
